export const accountsData = {
    type: "bar",
    data: {
        labels: ["کل", "معین", "تفضیلی", "شناور"],
        datasets: [
            {
                label: "دارای گردش",
                data: [90, 118, 34, 100],
                borderColor: "#FF8700",
                backgroundColor: "#FF8700",
                borderWidth: 3,
                hoverBorderWidth:5
            },
            {
                label: "تمام حساب ها",
                data: [150, 300, 235, 135],
                backgroundColor: "#002357",
                borderColor: "#002357",
                borderWidth: 3,
                hoverBorderWidth:5
            },

        ]
    },
    options: {
        responsive: true,
        scales: {
            xAxes: [{
                stacked: true,
                gridLines: {
                    display: false,
                }
            }],
            yAxes: [
                {
                    stacked: true,
                    gridLines: {
                        color: "rgba(161, 161, 161, .10)",
                    },
                    ticks: {
                        beginAtZero: true,
                        padding: 15
                    }
                }
            ]
        }
    }
};

export default accountsData;